import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  searchstring:string;

  constructor() { }

  ngOnInit(): void {
  }

  submit(searchstring): void {
    location.href="#/browseproducts/search/"+searchstring.split(' ').join('_')
  }

}
